import BodyColumnData from "@/components/body/BodyColumnData";
import BodyContainer from "@/components/body/BodyContainer";
import BodyValues from "@/components/body/BodyValues";
import Labs from "@/components/body/Labs";
import PatientDetailBody from "@/components/body/PatientDetailBody";
import Popups from "@/components/popups/";
import Alerts from "@/components/shared/Alerts";
import BodySharedFullData from "@/mixins/BodySharedFullData";
import Layout from "@/mixins/Layout";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    PatientDetailBody,
    Alerts,
    BodyContainer,
    BodyValues,
    Labs,
    BodyColumnData,
    ...Popups
  }
})
export default class DesktopFull extends Mixins(BodySharedFullData, Layout) {
  @Getter("current", patientNamespace)
  patient!: Patient;

  @Getter("area", patientNamespace)
  area!: string;

  additionalPartsToRemove: string[] = [];
  bodyWidthPixels: number = 500;

  mounted() {
    this.setBodyWidth();
  }

  @Watch("$vuetify.breakpoint.width")
  setBodyWidth() {
    // Body has not resized when this watch triggers
    // wait for next animation frame to adjust width
    requestAnimationFrame(() => {
      const wrapper = this.$refs.bodyContainerWrapper as Element;
      if (wrapper) {
        this.bodyWidthPixels = wrapper.clientWidth;
      }
    });
  }

  get bodyHeight() {
    // Adjust height to make head close to the top of its container
    const height = Math.floor(this.bodyWidthPixels * 0.9);
    return `${height}px`;
  }
}
